const setToken = (state, token) => {
  state.token = token;
};

const setUser = (state, user) => {
  state.user = user;
};

const setIdPuntoVenta = (state, idPuntoVenta) => {
  state.idPuntoVenta = idPuntoVenta;
};
const setConsultar = (state, consultar) => {
  state.consultar = consultar;
};

const setCompany = (state, company) => {
  state.company = company;
};



export default {
  setToken,
  setIdPuntoVenta,
  setConsultar,
  setUser,
  setCompany
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js